import { FormPageInputItemMultipleSelectionCheckbox } from 'shared';
import { MultipleSelectionValueForValidation } from '../shared';

export const convertMultipleSelectionCheckbox = (
  inputValue: FormPageInputItemMultipleSelectionCheckbox
): MultipleSelectionValueForValidation => {
  const { values, subtexts } = inputValue;
  if (values == null || values.length < 1) {
    return undefined;
  }
  return values.map((value) => ({
    value,
    subtext: subtexts?.find((subtext) => subtext.value === value)?.subtext,
  }));
};
